import React from 'react'

import { Link } from 'react-router-dom'

import { AiOutlineRight } from 'react-icons/ai'
import { RiGitCommitLine } from 'react-icons/ri'

const MenuItemSubMenu = ({ name, subMenuInfo }) => {
  const clickMenuItem = e => {
    e.preventDefault()

    e.currentTarget.parentNode.classList.toggle('open')
  }

  const clickLink = () => {
    const nodoBody = document.body
    nodoBody.classList.add('sidebar-hide')
  }

  return (
    <li>
      <a href='#!' onClick={clickMenuItem}>
        <RiGitCommitLine />
        <span>{name}</span>
        <AiOutlineRight />
      </a>
      <ul>
        {subMenuInfo.map((x, k) => (
          <li key={k}>
            <Link to={`/${x.page}`} onClick={clickLink}>
              <RiGitCommitLine />
              <span>{x.title}</span>
            </Link>
          </li>
        ))}
      </ul>
    </li>
  )
}

export default React.memo(MenuItemSubMenu)
